import script from "./MobileMain.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileMain.vue?vue&type=script&setup=true&lang=js"

import "./MobileMain.vue?vue&type=style&index=0&id=87c743c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87c743c8"]])

export default __exports__